import { Icon } from "@chakra-ui/react"

export const PersonIcon = (props: any) => (
  <Icon id="user_1_" data-name="user (1)" xmlns="http://www.w3.org/2000/svg" width="26.375" height="26.375" viewBox="0 0 26.375 26.375">
    <g id="Group_1167" data-name="Group 1167" transform="translate(0)">
      <path id="Path_564" data-name="Path 564" d="M22.513,17.05A13.137,13.137,0,0,0,17.5,13.907a7.624,7.624,0,1,0-8.627,0A13.208,13.208,0,0,0,0,26.375H2.061a11.127,11.127,0,0,1,22.254,0h2.061A13.1,13.1,0,0,0,22.513,17.05Zm-9.325-3.862a5.563,5.563,0,1,1,5.563-5.563A5.57,5.57,0,0,1,13.187,13.188Z" transform="translate(0)" fill="#06bcc1"/>
    </g>
  </Icon>
);
